import { onCLS, onFCP, onLCP, onTTFB } from 'web-vitals';

import { trackEvent } from './analytics.js';

import type { Metric } from 'web-vitals';

function reportMetric(metric: Metric): void {
  trackEvent('web_vitals', {
    metric_name: metric.name,
    // CLS is a unitless score; multiply by 1000 for precision.
    // All others are in milliseconds.
    value: Math.round(
      metric.name === 'CLS' ? metric.value * 1000 : metric.value
    ),
    rating: metric.rating,
  });
}

export function initWebVitals(): void {
  onCLS(reportMetric);
  onFCP(reportMetric);
  onLCP(reportMetric);
  onTTFB(reportMetric);
}
